<template>
    <v-dialog v-model="openViewB" fullscreen>
        <v-card>
            <v-container grid-list-xs fluid>
                <v-row>
                    <v-col cols="6" v-if="close">
                        <v-toolbar dark color="secondary" dense fixed>
                            <v-toolbar-title class="white--text">Actual Dispatch</v-toolbar-title>
                        </v-toolbar>
                    </v-col>
                    <v-col :cols="close == true ? '6' : '12'">
                        <v-toolbar dark color="secondary" dense fixed>
                            <v-toolbar-title class="white--text">Dispatch V3</v-toolbar-title>
                            <v-combobox v-model="cbx" placeholder="Select Region" class="mx-3" label="Select Region"
                                :items="regions" hide-details required dense :item-text="'PrincipalRegion'"
                                :item-value="'PrincipalRegionID'" auto-select-first></v-combobox>
                            <v-btn icon left @click="close = !close"><v-icon>mdi-eye-circle</v-icon></v-btn>
                            <v-spacer />
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon @click="splitLoads()">mdi-call-split</v-icon>
                                    </v-btn>
                                </template>
                                <span>Split Loads</span>
                            </v-tooltip>


                            <v-btn color="success" icon
                                v-if="$store.state.currentUser.id == 106 || $store.state.currentUser.id == 39 || this.$store.state.currentUser.id > 197"
                                @click="confirmRemplace"><v-icon>mdi-file-replace</v-icon></v-btn>

                            <v-btn icon @click="possibleHml">
                                <v-icon>mdi-home-map-marker</v-icon>
                            </v-btn>

                            <!-- Refresh Button -->
                            <v-btn icon @click="possibleMiddle">
                                <v-icon>mdi-format-align-middle</v-icon>
                            </v-btn>

                            <v-btn icon>
                                <v-icon @click="possibleShifts">mdi-file-find</v-icon>
                            </v-btn>

                            <v-btn icon left @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
                        </v-toolbar>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" v-if="close" style="overflow: auto;height: 600px;">
                        <div v-for="shift in filteredActual" :key="shift.ShiftDetail">
                            <v-card tile class="mb-4">
                                <v-toolbar :color="shift.isSpecific > 0
                                    ? '#00838F'
                                    : 'primary'
                                    " dark dense>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on">
                                                {{ statusIcon }}
                                            </v-icon>
                                        </template>
                                        <span>
                                            Locked by Admin:
                                            <!-- {{ shift.Finalize ? 'Yes' : 'No' }} -->
                                            <br />
                                            Finalized:
                                            {{
                                                shift.DispatchFinalize
                                                    ? 'Yes'
                                                    : 'No'
                                            }}
                                            <v-divider />
                                            Driver login:
                                            {{
                                                formatHumanReadableDateTime(
                                                    shift.LogStart
                                                )
                                            }}
                                            <br />
                                            Driver logout:
                                            {{
                                                formatHumanReadableDateTime(
                                                    shift.LogEnd
                                                )
                                            }}
                                        </span>
                                    </v-tooltip>
                                    <v-toolbar-title class="ma-2" style="font-size: medium;">
                                        <v-row no-gutters>
                                            <v-col align-self="center" class="mr-2">
                                                <span class="text-subtitle-2 font-weight-bold">
                                                    <v-icon small>mdi-identifier</v-icon>
                                                    {{ shift.ShiftDetail }}
                                                </span>
                                                <v-divider />
                                                <span class="text-subtitle-2 ">
                                                    <v-icon small left class="mdi-flip-h">mdi-truck-flatbed</v-icon>
                                                    {{ shift.Truck }}
                                                </span>
                                            </v-col>
                                            <v-col align-self="center" class="">
                                                <span class="text-subtitle-2 font-weight-bold">
                                                    <v-icon small>mdi-account</v-icon>
                                                    {{ shift.driver.Name }}
                                                </span>
                                                <v-divider />
                                                <span class="text-subtitle-2">
                                                    <v-icon small left>mdi-train-car-container</v-icon>
                                                    {{ shift.Trailer }}
                                                </span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Start Time: <br />
                                                    {{
                                                        shift.ShiftStartTime
                                                    }}</span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Yard:
                                                    <span
                                                        v-if="(shift.GPSShiftStartOrigin === 1 || shift.GPSShiftStartOrigin === null)"
                                                        style="background: #01579b;border-radius: 3px; padding: 2px; color:#fff;">{{
                                                            shift.ExitTime
                                                        }}</span>
                                                    <span v-if="shift.GPSShiftStartOrigin > 1"
                                                        style="background: red;border-radius: 3px; padding: 2px; color:#fff;">{{
                                                            shift.RealExitTime
                                                        }}</span>
                                                    <br />
                                                    {{ shift.Yard }}</span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Shift Hrs: <br />
                                                    {{ shift.HrsAviable }}/{{
                                                        shift.TargetHours
                                                    }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-menu bottom left offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-item v-for="(item,
                                                    index) in menuItems(shift)" :key="index" @click="item.click"
                                                    v-if="item.view == 0">
                                                    <v-list-item-icon>
                                                        <v-icon>{{
                                                            item.icon
                                                            }}</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-title>
                                                        {{ item.title }}
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-row class="blue-grey lighten-4" no-gutters>
                                    <v-col cols="6">
                                        <span class="ml-2 font-weight-bold">Load:</span>
                                        <template v-for="badge in shift.driver.badges">
                                            <abbr style="text-decoration: none;" :title="badge.TerminalName"
                                                v-if="badge.BadgeType == 1">
                                                <v-icon class="my-2 ml-2 "
                                                    :color="badge.Color">mdi-card-bulleted</v-icon>
                                            </abbr>
                                        </template>
                                    </v-col>
                                    <v-col cols="5">
                                        <span class="ml-2 font-weight-bold">Unload:</span>
                                        <template v-for="badge in shift.driver.badges">
                                            <abbr style="text-decoration: none;" :title="badge.TerminalName"
                                                v-if="badge.BadgeType == 2">
                                                <v-icon class="my-2 ml-2 "
                                                    :color="badge.Color">mdi-card-bulleted</v-icon>
                                            </abbr>
                                        </template>
                                    </v-col>
                                    <v-col cols="1" justify="end">
                                        <v-btn plain style="right: 0;">
                                            <v-icon>mdi-chevron-up</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-data-table dense :headers="orderHeaders" :items="shift.orders" item-key="OrderID"
                                    :items-per-page="-1" :disable-pagination="true" :hide-default-footer="true">
                                    <template v-slot:body="props">
                                        <tr v-for="(order, index) in props.items" :key="order.OrderID" class="py-2"
                                            :style="'background:' + order.ColorLoad
                                                ">
                                            <td>
                                                <v-icon :class="order.OrdLoadStatus ===
                                                    'INPROGRESS'
                                                    ? 'bouncing'
                                                    : ''
                                                    " :color="getOrderLoadStatus(
                                                        order,
                                                        'color'
                                                    )
                                                        " class="my-2 pa-0 ml-0 grab-icon">
                                                    {{
                                                        getOrderLoadStatus(
                                                            order,
                                                            'icon'
                                                        )
                                                    }}
                                                </v-icon>
                                            </td>
                                            <td>
                                                <v-icon :color="getOrderLoadStatus(
                                                    order,
                                                    'color'
                                                )
                                                    ">
                                                    mdi-numeric-{{
                                                        order.LoadNum
                                                    }}-box
                                                </v-icon>
                                            </td>
                                            <td>
                                                <v-icon :style="order.LoadNumOrd
                                                    ? ''
                                                    : 'opacity: 0.2;'
                                                    " :color="getOrderLoadStatus(
                                                        order,
                                                        'color'
                                                    )
                                                        ">
                                                    mdi-numeric-{{
                                                        order.LoadNumOrd || 0
                                                    }}-box
                                                </v-icon>
                                            </td>
                                            <td>{{ order.OrderID }}
                                                <span v-if="order.OrderStatus != 'DISPATCHED'" class="font-weight-bold"
                                                    :class="order.OrderStatus == 'PRLDISPAT'
                                                        ? 'green--text'
                                                        : order.OrderStatus == 'PRELOAD'
                                                            ? 'orange--text'
                                                            : ''
                                                        " style="font-size: 9px;">
                                                    {{
                                                        order.OrderStatus == 'PRLDISPAT'
                                                            ? 'PREDISPATCH'
                                                            : order.OrderStatus
                                                    }}
                                                </span>
                                            </td>
                                            <td>
                                                <v-chip class="ml-2 my-2 " label>
                                                    <v-avatar class="py-2" left tile :color="order.Color ||
                                                        'grey'
                                                        ">
                                                        <v-icon small dark>mdi-water-pump</v-icon>
                                                    </v-avatar>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{
                                                            on
                                                        }">
                                                            <span class="location"
                                                                style="width:180px;font-family: Tahoma, sans-serif;font-stretch: ultra-condensed;"
                                                                v-on="on">
                                                                {{
                                                                    order.Terminal
                                                                }}
                                                            </span>
                                                        </template>
                                                        <span>
                                                            <v-icon small left :color="order
                                                                .terminal
                                                                ?.Color ||
                                                                'grey'
                                                                ">
                                                                mdi-water-pump
                                                            </v-icon>
                                                            {{ order.Terminal }}
                                                        </span>
                                                    </v-tooltip>
                                                </v-chip>
                                            </td>
                                            <td>
                                                <v-chip class="ml-2 my-2" label>
                                                    <v-avatar class="py-2" left tile color="green ">
                                                        <v-icon small dark>mdi-gas-station</v-icon>
                                                    </v-avatar>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{
                                                            on
                                                        }">
                                                            <span class="location"
                                                                style="width:180px;font-stretch: condensed;" v-on="on">
                                                                {{
                                                                    order.StationName
                                                                }}
                                                            </span>
                                                        </template>
                                                        <span>
                                                            <v-icon small left
                                                                color="green lighten-3">mdi-gas-station</v-icon>
                                                            {{
                                                                order.StationName
                                                            }}
                                                        </span>
                                                    </v-tooltip>
                                                </v-chip>
                                            </td>
                                            <td>{{ order.station.City }}</td>
                                            <td>
                                                <v-btn v-if="order" small text :style="{
                                                    color: checkTrailerCapacity(
                                                        getOrderQuantities(
                                                            order
                                                        ),
                                                        'color'
                                                    )
                                                }" class="font-weight-bold ma-0 pa-0" :class="checkTrailerCapacity(
                                                    getOrderQuantities(
                                                        order
                                                    ),
                                                    'boolean'
                                                )
                                                    ? ''
                                                    : 'pulsing'
                                                    " @click="
                                                        openAutoAssignQuantities(
                                                            order
                                                        )
                                                        " :disabled="order.Finalize == 1 ||
                                                            order.OrdLoadStatus ==
                                                            'DONE'
                                                            ">
                                                    {{
                                                        formatLargeNumber(
                                                            getOrderQuantities(
                                                                order
                                                            )
                                                        )
                                                    }}
                                                    Lts.
                                                </v-btn>
                                            </td>
                                            <td>
                                                <span v-if="order.Finalize !== 1">
                                                    {{
                                                        timeUntil(
                                                            closestRunout(
                                                                order
                                                            ) ?? order.RTTime,
                                                            'HH'
                                                        )
                                                    }}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="order.Finalize !== 1" :class="!closestRunout(order) &&
                                                    order.ROTime
                                                    ? 'font-weight-bold'
                                                    : ''
                                                    ">
                                                    {{
                                                        timeUntil(
                                                            closestRunout(
                                                                order
                                                            ) ?? order.ROTime,
                                                            'HH'
                                                        )
                                                    }}
                                                </span>
                                            </td>
                                            <td>
                                                <template v-if="order.Finalize !== 1">
                                                    {{
                                                        timeUntil(
                                                            order.ETATime,
                                                            'HH'
                                                        )
                                                    }}
                                                </template>
                                                <template v-else>
                                                    <v-icon color="green">mdi-check</v-icon>
                                                </template>
                                            </td>
                                            <td>
                                                {{ Number(order.EstimateTime).toFixed(2) }}
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </div>
                    </v-col>
                    <v-col cols="5" v-if="!close">
                        <v-toolbar dark color="primary" dense>
                            Filters
                        </v-toolbar>
                        <v-container grid-list-xs fluid>
                            <v-combobox label="Filters" v-model="filterOrd" :items="filters" dense
                                @change="printLog()"></v-combobox>
                            <v-text-field label="Search" dense v-model="search"></v-text-field>
                        </v-container>
                        <v-toolbar dark color="primary" dense>
                            SandBox Line Up
                        </v-toolbar>
                        <!-- Line Up Only - Plan B -->
                        <v-data-table fixed-header dense :headers="headers" :items="filteredOrders" item-key="OrderID"
                            :items-per-page="-1" :disable-pagination="true" :hide-default-footer="true" height="80vh">
                            <template v-slot:body="props">
                                <draggable :list="props.items" :group="'OrderID'" tag="tbody"
                                    style="min-height: 200px;padding: 20px;" :delay="0" ghost-class="ghost"
                                    animation="100">
                                    <tr @contextmenu.prevent="openContextMenu(order)"
                                        v-for="(order, index) in props.items" :key="order.OrderID" class="py-2">
                                        <td class="custom-cell">
                                            <!-- {{ timeUntil(order.RTTime, 'HH') }} -->
                                            {{ order.RTHrs }}
                                        </td>
                                        <td class="custom-cell">
                                            <!-- {{ timeUntil(order.ROTime, 'HH') }} -->
                                            {{ order.ROHrs }}
                                        </td>
                                        <td class="custom-cell" style="cursor: pointer;"
                                            @click="getOrderDetails(order.OrderID, true)">
                                            {{ order.OrderID }}
                                        </td>
                                        <!-- <td class="custom-cell">
                                            <v-icon small :color="order.TerminalColor">
                                                mdi-water-pump
                                            </v-icon>
                                        </td> -->
                                        <td class="custom-cell">
                                            <v-chip class="ml-2 my-2 " label>
                                                <v-avatar class="py-2" left tile :color="order.terminal.Color ||
                                                    'grey'
                                                    ">
                                                    <v-icon small dark>mdi-water-pump</v-icon>
                                                </v-avatar>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{
                                                        on
                                                    }">
                                                        <span class="location"
                                                            style="width:180px;font-family: Tahoma, sans-serif;font-stretch: ultra-condensed;"
                                                            v-on="on">
                                                            {{
                                                                order.TerminalName
                                                            }}
                                                        </span>
                                                    </template>
                                                    <span>
                                                        <v-icon small left :color="order
                                                            .terminal
                                                            ?.Color ||
                                                            'grey'
                                                            ">
                                                            mdi-water-pump
                                                        </v-icon>
                                                        {{ order.TerminalName }}
                                                    </span>
                                                </v-tooltip>
                                            </v-chip>
                                        </td>
                                        <td class="custom-cell">
                                            {{
                                                order.StationName
                                            }}
                                        </td>
                                        <td class="custom-cell">
                                            <!-- {{ formatIndependentTime(order.EH) }} -->
                                            {{ order.AVGHE }}
                                        </td>
                                        <td class="custom-cell">
                                            <v-tooltip right>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon small v-on="on" @click="
                                                        viewOrder(order)
                                                        ">
                                                        <v-icon
                                                            :color="order.OrderStatus == 'ACTIVE' ? '' : 'green'">mdi-file-document-outline</v-icon>
                                                    </v-btn>
                                                </template>
                                            </v-tooltip>
                                        </td>
                                        <td>
                                            <v-icon v-if="order.isSpecific == 1" color="#e6c10b" small>mdi-star</v-icon>
                                        </td>
                                    </tr>
                                </draggable>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col :cols="close == true ? '6' : '7'" :style="close == false
                        ? 'overflow: auto;height:1000px;'
                        : 'overflow: auto;height:600px;'
                        ">
                        <div v-for="shift in filteredPlanB" :key="shift.ShiftDetail">
                            <v-card tile class="mb-4">
                                <v-toolbar :color="shift.isSpecific > 0
                                    ? '#00838F'
                                    : 'primary'
                                    " dark dense>
                                    <v-checkbox hide-details v-model="shift.whyNotCheck"
                                        :value="shift.whyNotCheck"></v-checkbox>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on">
                                                {{ statusIcon }}
                                            </v-icon>
                                        </template>
                                        <span>
                                            Locked by Admin:
                                            <!-- {{ shift.Finalize ? 'Yes' : 'No' }} -->
                                            <br />
                                            Finalized:
                                            {{
                                                shift.DispatchFinalize
                                                    ? 'Yes'
                                                    : 'No'
                                            }}
                                            <v-divider />
                                            Driver login:
                                            {{
                                                formatHumanReadableDateTime(
                                                    shift.LogStart
                                                )
                                            }}
                                            <br />
                                            Driver logout:
                                            {{
                                                formatHumanReadableDateTime(
                                                    shift.LogEnd
                                                )
                                            }}
                                        </span>
                                    </v-tooltip>
                                    <v-toolbar-title class="ma-2" style="font-size: medium;">
                                        <v-row no-gutters>
                                            <v-col align-self="center" class="mr-2">
                                                <span class="text-subtitle-2 font-weight-bold">
                                                    <v-icon small>mdi-identifier</v-icon>
                                                    {{ shift.ShiftDetail }}
                                                </span>
                                                <v-divider />
                                                <span class="text-subtitle-2 ">
                                                    <v-icon small left class="mdi-flip-h">mdi-truck-flatbed</v-icon>
                                                    {{ shift.Truck }}
                                                </span>
                                            </v-col>
                                            <v-col align-self="center" class="">
                                                <span class="text-subtitle-2 font-weight-bold">
                                                    <v-icon small>mdi-account</v-icon>
                                                    {{ shift.driver.Name }}
                                                </span>
                                                <v-divider />
                                                <span class="text-subtitle-2">
                                                    <v-icon small left>mdi-train-car-container</v-icon>
                                                    {{ shift.Trailer }}
                                                </span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Start Time: <br />
                                                    {{
                                                        shift.ShiftStartTime
                                                    }}</span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Yard:
                                                    <span v-if="
                                                        shift.GPSShiftStartOrigin ==
                                                        1
                                                    "
                                                        style="background: #01579b;border-radius: 3px; padding: 2px; color:#fff;">{{
                                                            shift.ExitTime
                                                        }}</span>
                                                    <span v-if="
                                                        shift.GPSShiftStartOrigin >
                                                        1
                                                    "
                                                        style="background: red;border-radius: 3px; padding: 2px; color:#fff;">{{
                                                            shift.RealExitTime
                                                        }}</span>
                                                    <br />
                                                    {{ shift.Yard }}
                                                </span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Shift Hrs: <br />
                                                    {{ Number(shift.HrsAvailable3).toFixed(2) }}/{{
                                                        shift.TargetHours
                                                    }} </span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                        </v-row>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-menu bottom left offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-item v-for="(item,
                                                    index) in menuItems(shift)" :key="index" @click="item.click()"
                                                    v-if="item.view == 0">
                                                    <v-list-item-icon>
                                                        <v-icon>{{
                                                            item.icon
                                                            }}</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-title>
                                                        {{ item.title }}
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-row class="blue-grey lighten-4" no-gutters>
                                    <v-col cols="6">
                                        <span class="ml-2 font-weight-bold">Load:</span>
                                        <template v-for="badge in shift.driver.badges">
                                            <abbr style="text-decoration: none;" :title="badge.TerminalName"
                                                v-if="badge.BadgeType == 1">
                                                <v-icon class="my-2 ml-2 "
                                                    :color="badge.Color">mdi-card-bulleted</v-icon>
                                            </abbr>
                                        </template>
                                    </v-col>
                                    <v-col cols="5">
                                        <span class="ml-2 font-weight-bold">Unload:</span>
                                        <template v-for="badge in shift.driver.badges">
                                            <abbr style="text-decoration: none;" :title="badge.TerminalName"
                                                v-if="badge.BadgeType == 2">
                                                <v-icon class="my-2 ml-2 "
                                                    :color="badge.Color">mdi-card-bulleted</v-icon>
                                            </abbr>
                                        </template>
                                    </v-col>
                                    <v-col cols="1" justify="end">
                                        <v-btn plain style="right: 0;">
                                            <v-icon>mdi-chevron-up</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <!-- Dispatch PlanB Orderes by Shift -->
                                <v-data-table dense :headers="orderHeaders" :items="shift.orders_3" item-key="OrderID"
                                    :items-per-page="-1" :disable-pagination="true" :hide-default-footer="true"
                                    style="min-height: 200px">
                                    <template v-slot:body="props">
                                        <draggable v-model="shift.orders_3" group="OrderID" :id="shift.ShiftDetail"
                                            @update="reorderLoads(shift.orders_3, shift, 1)"
                                            @add="addOrder(shift.orders_3, shift)"
                                            @remove="removeOrder(shift.orders_3, shift, $event)"
                                            @start="onDragStart(shift.orders_3, $event)" tag="tbody" :style="{
                                                minHeight: '200px',
                                                padding: '20px',
                                                display: props.items.length === 0 ? 'block' : 'table-row-group',
                                                position: props.items.length === 0 ? 'absolute' : 'relative',
                                                width: '100%'
                                            }" :delay="0" ghost-class="ghost" animation="100">
                                            <template v-if="props.items.length">
                                                <template v-for="(order, index) in props.items">
                                                    <tr class="py-2 grab-icon"
                                                        @contextmenu.prevent="$refs.menuLoads.open($event, order)"
                                                        :class="order.OrdLoadStatus === 'DONE' ? '' : ''"
                                                        :style="'background:' + order.ColorLoad">
                                                        <td>
                                                            <v-icon :class="order.OrdLoadStatus ===
                                                                'INPROGRESS'
                                                                ? 'bouncing'
                                                                : ''
                                                                " :color="getOrderLoadStatus(
                                                                    order,
                                                                    'color'
                                                                )
                                                                    " class="my-2 pa-0 ml-0 grab-icon">
                                                                {{
                                                                    getOrderLoadStatus(
                                                                        order,
                                                                        'icon'
                                                                    )
                                                                }}
                                                            </v-icon>
                                                        </td>
                                                        <td>
                                                            <v-icon :color="getOrderLoadStatus(
                                                                order,
                                                                'color'
                                                            )
                                                                ">
                                                                mdi-numeric-{{ order.LoadNum }}-box
                                                            </v-icon>
                                                        </td>
                                                        <td>
                                                            <v-icon :style="order.LoadNumOrd
                                                                ? ''
                                                                : 'opacity: 0.2;'
                                                                " :color="getOrderLoadStatus(
                                                                    order,
                                                                    'color'
                                                                )
                                                                    ">
                                                                mdi-numeric-{{
                                                                    order.LoadNumOrd ||
                                                                    0
                                                                }}-box
                                                            </v-icon>
                                                        </td>
                                                        <td @click="getOrderDetails(order.OrderID, false)">{{
                                                            order.OrderID
                                                        }}
                                                            <span v-if="order.OrderStatus != 'DISPATCHED'"
                                                                class="font-weight-bold" :class="order.OrderStatus == 'PRLDISPAT'
                                                                    ? 'green--text'
                                                                    : order.OrderStatus == 'PRELOAD'
                                                                        ? 'orange--text'
                                                                        : ''
                                                                    " style="font-size: 9px;">
                                                                {{
                                                                    order.OrderStatus == 'PRLDISPAT'
                                                                        ? 'PREDISPATCH'
                                                                        : order.OrderStatus
                                                                }}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <v-chip class="ml-2 my-2 " label>
                                                                <v-avatar class="py-2" left tile :color="order.terminal.Color ||
                                                                    'grey'
                                                                    ">
                                                                    <v-icon small dark>mdi-water-pump</v-icon>
                                                                </v-avatar>
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{
                                                                        on
                                                                    }">
                                                                        <span class="location"
                                                                            style="width:180px;font-family: Tahoma, sans-serif;font-stretch: ultra-condensed;"
                                                                            v-on="on
                                                                                ">
                                                                            {{
                                                                                order.terminal.TerminalName
                                                                            }}
                                                                        </span>
                                                                    </template>
                                                                    <span>
                                                                        <v-icon small left :color="order
                                                                            .terminal
                                                                            ?.Color ||
                                                                            'grey'
                                                                            ">
                                                                            mdi-water-pump
                                                                        </v-icon>
                                                                        {{
                                                                            order.Terminal
                                                                        }}
                                                                    </span>
                                                                </v-tooltip>
                                                            </v-chip>
                                                        </td>
                                                        <td>
                                                            <v-chip class="ml-2 my-2" label>
                                                                <v-avatar class="py-2" left tile color="green ">
                                                                    <v-icon small dark>mdi-gas-station</v-icon>
                                                                </v-avatar>
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{
                                                                        on
                                                                    }">
                                                                        <span class="location"
                                                                            style="width:180px;font-stretch: condensed;"
                                                                            v-on="on
                                                                                ">
                                                                            {{
                                                                                order.StationName
                                                                            }}
                                                                        </span>
                                                                    </template>
                                                                    <span>
                                                                        <v-icon small left
                                                                            color="green lighten-3">mdi-gas-station</v-icon>
                                                                        {{
                                                                            order.StationName
                                                                        }}
                                                                    </span>
                                                                </v-tooltip>
                                                            </v-chip>
                                                        </td>
                                                        <td>
                                                            {{ order.station.City }}
                                                        </td>
                                                        <td>
                                                            <v-btn v-if="order" small text :style="{
                                                                color: checkTrailerCapacity(
                                                                    getOrderQuantities(
                                                                        order
                                                                    ),
                                                                    'color'
                                                                )
                                                            }" class="font-weight-bold ma-0 pa-0" :class="checkTrailerCapacity(
                                                                getOrderQuantities(
                                                                    order
                                                                ),
                                                                'boolean'
                                                            )
                                                                ? ''
                                                                : 'pulsing'
                                                                " @click="
                                                                    openAutoAssignQuantities(
                                                                        order
                                                                    )
                                                                    " :disabled="order.Finalize ==
                                                                        1 ||
                                                                        order.OrdLoadStatus ==
                                                                        'DONE'
                                                                        ">
                                                                {{
                                                                    formatLargeNumber(
                                                                        getOrderQuantities(
                                                                            order
                                                                        )
                                                                    )
                                                                }}
                                                                Lts.
                                                            </v-btn>
                                                        </td>
                                                        <td>
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <span v-bind="attrs
                                                                        " v-on="on"
                                                                        style="background: #01579b;border-radius: 3px; padding: 2px; color:#fff;">
                                                                        {{
                                                                            order.RTHrs
                                                                        }}
                                                                    </span>
                                                                </template>
                                                                <span>
                                                                    {{
                                                                        order.RTTime
                                                                    }}
                                                                </span>
                                                            </v-tooltip>
                                                        </td>
                                                        <td>
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <span v-bind="attrs
                                                                        " v-on="on"
                                                                        style="background: #01579b;border-radius: 3px; padding: 2px; color:#fff;">
                                                                        {{
                                                                            order.ROHrs
                                                                        }}
                                                                    </span>
                                                                </template>
                                                                <span>
                                                                    {{
                                                                        order.ROTime
                                                                    }}
                                                                </span>
                                                            </v-tooltip>
                                                        </td>
                                                        <td>
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <span v-bind="attrs
                                                                        " v-on="on"
                                                                        style="background: #01579b;border-radius: 3px; padding: 2px; color:#fff;">
                                                                        {{
                                                                            order.ETAHrs
                                                                        }}
                                                                    </span>
                                                                </template>
                                                                <span>
                                                                    {{
                                                                        order.ETATime
                                                                    }}
                                                                </span>
                                                            </v-tooltip>
                                                        </td>
                                                        <td>
                                                            <v-menu offset-y>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-bind="attrs" v-on="on"
                                                                        style="cursor: pointer; background: #01579b; border-radius: 3px; padding: 2px; color:#fff;">
                                                                        {{ order.eh_3 ? Number(order.eh_3).toFixed(2) :
                                                                            Number(order.EstimateTime).toFixed(2) }}
                                                                    </span>
                                                                </template>
                                                                <v-card>
                                                                    <v-simple-table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Event</th>
                                                                                <th>Duration (in mins)</th>
                                                                                <th>Calculation Method</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <template
                                                                                v-if="parsedDurationBreakup(order.duration_breakup)">
                                                                                <tr v-for="(value, key) in parsedDurationBreakup(order.duration_breakup)"
                                                                                    :key="key">
                                                                                    <td class="text-left"
                                                                                        v-html="an_getEHEventKeyNameForDurationBreakUp(key, value, props.items, shift, index)">
                                                                                    </td>
                                                                                    <td class="text-left">{{
                                                                                        Number(value.time).toFixed(2) }}
                                                                                    </td>
                                                                                    <td class="text-left">
                                                                                        <v-icon color="black" small
                                                                                            v-if="getCalculationMethod(value.calculated_using) === 'Geotab'"
                                                                                            title="Geotab">mdi-satellite-variant</v-icon>
                                                                                        <v-icon color="black" small
                                                                                            v-if="getCalculationMethod(value.calculated_using) === 'Google'"
                                                                                            title="Google">mdi-map</v-icon>
                                                                                        {{
                                                                                            getCalculationMethod(value.calculated_using)
                                                                                        }}
                                                                                    </td>
                                                                                </tr>
                                                                                <tr :class="{ 'highlight-row': true }">
                                                                                    <td class="text-left">Sum of
                                                                                        Delivery
                                                                                        Route Durations</td>
                                                                                    <td class="text-left">{{
                                                                                        totalDuration(order.duration_breakup)
                                                                                    }} ({{
                                                                                            Number(totalDuration(order.duration_breakup)
                                                                                                /
                                                                                                60).toFixed(2) }} hrs)
                                                                                    </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                            </template>
                                                                            <tr v-else>
                                                                                <td colspan="2" class="text-center">No
                                                                                    Data
                                                                                    Available</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </v-simple-table>
                                                                </v-card>
                                                            </v-menu>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>

                                            <template v-else>
                                                <div colspan="10"
                                                    style="height: 50px;text-align: center; color: gray;top: 50px;position: relative;">
                                                </div>
                                            </template>
                                        </draggable>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>
                <v-row v-if="close">
                    <v-col cols="8">
                        <v-toolbar dark color="primary" dense>
                            SandBox Line Up
                        </v-toolbar>
                        <!-- Line Up Only - Plan B -->
                        <v-data-table fixed-header dense :headers="headers" :items="filteredOrders" item-key="OrderID"
                            :items-per-page="-1" :disable-pagination="true" :hide-default-footer="true" height="80vh">
                            <template v-slot:body="props">
                                <draggable :list="props.items" :group="'OrderID'" tag="tbody"
                                    style="min-height: 200px;padding: 20px;" :delay="0" ghost-class="ghost"
                                    animation="100">
                                    <tr @contextmenu.prevent="openContextMenu(order)"
                                        v-for="(order, index) in props.items" :key="order.OrderID" class="py-2">
                                        <td class="custom-cell">
                                            <!-- {{ timeUntil(order.RTTime, 'HH') }} -->
                                            {{ order.RTHrs }}
                                        </td>
                                        <td class="custom-cell">
                                            <!-- {{ timeUntil(order.ROTime, 'HH') }} -->
                                            {{ order.ROHrs }}
                                        </td>
                                        <td class="custom-cell">
                                            {{ order.OrderID }}
                                        </td>
                                        <!-- <td class="custom-cell">
                                            <v-icon small :color="order.TerminalColor">
                                                mdi-water-pump
                                            </v-icon>
                                        </td> -->
                                        <td class="custom-cell">
                                            <v-chip class="ml-2 my-2 " label>
                                                <v-avatar class="py-2" left tile :color="order.terminal.Color ||
                                                    'grey'
                                                    ">
                                                    <v-icon small dark>mdi-water-pump</v-icon>
                                                </v-avatar>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{
                                                        on
                                                    }">
                                                        <span class="location"
                                                            style="width:180px;font-family: Tahoma, sans-serif;font-stretch: ultra-condensed;"
                                                            v-on="on">
                                                            {{
                                                                order.TerminalName
                                                            }}
                                                        </span>
                                                    </template>
                                                    <span>
                                                        <v-icon small left :color="order
                                                            .terminal
                                                            ?.Color ||
                                                            'grey'
                                                            ">
                                                            mdi-water-pump
                                                        </v-icon>
                                                        {{ order.TerminalName }}
                                                    </span>
                                                </v-tooltip>
                                            </v-chip>
                                        </td>
                                        <td class="custom-cell">
                                            {{
                                                order.StationName
                                            }}
                                        </td>
                                        <td class="custom-cell">
                                            <!-- {{ formatIndependentTime(order.EH) }} -->
                                            {{ order.AVGHE }}
                                        </td>
                                        <td class="custom-cell">
                                            <v-tooltip right>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon small v-on="on" @click="viewOrder(order)">
                                                        <v-icon
                                                            :color="order.OrderStatus == 'ACTIVE' ? '' : 'green'">mdi-file-document-outline</v-icon>
                                                    </v-btn>
                                                </template>
                                            </v-tooltip>
                                        </td>
                                        <td>
                                            <v-icon v-if="order.isSpecific == 1" color="#e6c10b" small>mdi-star</v-icon>
                                        </td>
                                    </tr>
                                </draggable>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="4">
                        <v-toolbar dark color="primary" dense>
                            Filters
                        </v-toolbar>
                        <v-container grid-list-xs fluid>
                            <v-combobox label="Filters" v-model="filterOrd" :items="filters" dense
                                @change="printLog()"></v-combobox>
                            <v-text-field label="Search" dense v-model="search"></v-text-field>
                        </v-container>
                    </v-col>
                </v-row>
                <vue-context ref="menu">
                    <template slot-scope="selectedOrder">
                        <li>
                            <a @click="
                                whyNotHomeLoad(
                                    selectedOrder.data,
                                    'Homelaod'
                                )
                                ">
                                Reason
                            </a>
                        </li>
                        <li>
                            <a @click="
                                viewOrder(
                                    selectedOrder.data,
                                )
                                ">
                                View Order
                            </a>
                        </li>
                    </template>
                </vue-context>

                <vue-context ref="menuLoads">
                    <template slot-scope="selectedOrder">
                        <v-list dense style="margin:0px;padding:0px;">
                            <v-list-item-group color="primary">
                                <v-list-item @click="viewOrder(selectedOrder.data)">
                                    <v-list-item-icon>
                                        <v-icon v-text="'mdi-pencil'"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="'View Order'"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item @click="splitOrder(selectedOrder.data)">
                                    <v-list-item-icon>
                                        <v-icon v-text="'mdi-call-split'"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="'Split Order'"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item @click="unSplitOrder(selectedOrder.data)">
                                    <v-list-item-icon>
                                        <v-icon v-text="'mdi-vector-line'"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="'Un-Split Order'"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </template>
                </vue-context>
                <ordView v-if="dialogOrder" :dialog="dialogOrder" @close="dialogOrder = false;" :OrderInfo="OrderInfo">
                </ordView>
                <whynt v-if="viewWhy" :viewWhy="viewWhy" :dataWhy="dataWhy" @closeWNM="viewWhy = false"></whynt>
            </v-container>
        </v-card>
        <ShortLoads v-if="vDialogLoads" :vDialogLoads="vDialogLoads" :LoadsInfo="LoadsInfo"
            @close="vDialogLoads = false;">
        </ShortLoads>
        <showmiddle v-if="vDialogLoadMiddle" :vDialogLoadMiddle="vDialogLoadMiddle" :LoadsInfoMiddle="LoadsInfoMiddle"
            @close="vDialogLoadMiddle = false;"></showmiddle>
        <ShortShift v-if="vDialogShifts" :vDialogShifts="vDialogShifts" :ShiftsInfo="ShiftsInfo"
            @close="vDialogShifts = false;"></ShortShift>
        <SplitModal v-if="dialogSplit" :dialogProp="dialogSplit" :ShiftDetail="ShiftDetailSplit" :loads="loadsSplits"
            @close="dialogSplit = false;" @save-close="splitsSave"></SplitModal>

        <confirm-dialogue ref="confirmRplc"></confirm-dialogue>

        <v-dialog v-model="showModal" max-width="1000px">
            <v-card v-if="orderAssignmentReason">
                <v-card-title class="headline d-flex align-center">
                    <span class="font-weight-bold" style="margin-right: 10px;">Assignment Failed</span>
                    <v-icon color="red" size="30">mdi-close-circle</v-icon>
                </v-card-title>

                <v-card-text style="padding-bottom: 10px;">
                    <v-card outlined class="mb-4">
                        <v-card-title class="table-heading">Primary Conditions</v-card-title>
                        <v-divider></v-divider>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th class="text-left">Condition</th>
                                    <th class="text-left">Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(value, key) in orderAssignmentReason.primary_condition"
                                    :key="'primary-' + key"
                                    :class="{ 'highlight-rows': shouldHighlightRow(key, value) }">
                                    <td>
                                        {{ key }}
                                    </td>
                                    <td>
                                        <v-icon v-if="typeof value === 'boolean'" :color="value ? 'green' : 'white'">
                                            {{ value ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                        </v-icon>
                                        <span v-else>{{ value }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>

                    <!-- Secondary Condition Section -->
                    <v-card outlined class="mb-4">
                        <v-card-title class="table-heading">Secondary Conditions</v-card-title>
                        <v-divider></v-divider>

                        <!-- EH Hours & Hours Available Table -->
                        <v-simple-table dense>
                            <tbody>
                                <tr
                                    :class="{ 'highlight-rows': orderAssignmentReason.secondary_condition.eh_hour > orderAssignmentReason.secondary_condition.hour_available_3 }">
                                    <td>EH Hours</td>
                                    <td>{{ orderAssignmentReason.secondary_condition.eh_hour }} hr</td>
                                </tr>
                                <tr>
                                    <td><strong>Hours Available</strong></td>
                                    <td>{{ orderAssignmentReason.secondary_condition.hour_available_3 }} hr</td>
                                </tr>
                            </tbody>
                        </v-simple-table>

                        <!-- Duration Breakup Table -->
                        <v-card outlined>
                            <v-card-title class="table-heading"
                                style="font-size: 14px; padding-top: 0; padding-bottom: 0;"><strong>Duration
                                    Breakup</strong></v-card-title>
                            <v-divider></v-divider>
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th class="text-left">Stage</th>
                                        <th class="text-left">Time (min)</th>
                                        <th class="text-left">Calculated Using</th>
                                    </tr>
                                </thead>
                                <tbody v-if="orderAssignmentReason.secondary_condition">
                                    <tr v-for="(value, key) in parsedDurationBreakup(orderAssignmentReason.secondary_condition.duration_breakup)"
                                        :key="'duration-' + key">
                                        <td>{{ key }}</td>
                                        <td>{{ value.time }}</td>
                                        <td>{{ value.calculated_using }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card>
                    </v-card>

                    <v-card outlined v-if="parsedDurationBreakup(orderAssignmentReason.goal_post)">
                        <v-card-title class="table-heading">Goal Post Conditions</v-card-title>
                        <v-divider></v-divider>

                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th class="text-left">Statement</th>
                                    <th class="text-left">Goal Post</th>
                                    <th class="text-left">RT Time (hr)</th>
                                    <th class="text-left">RO Time (hr)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ parsedDurationBreakup(orderAssignmentReason.goal_post).statement }}</td>
                                    <td>
                                        <span class="goal-post-circle"
                                            :class="getGoalPostClass(parsedDurationBreakup(orderAssignmentReason.goal_post).badge)">
                                        </span>
                                    </td>
                                    <td>{{ (parsedDurationBreakup(orderAssignmentReason.goal_post).RTTime /
                                        60).toFixed(2) }}
                                    </td>
                                    <td>{{ (parsedDurationBreakup(orderAssignmentReason.goal_post).ROTime /
                                        60).toFixed(2) }}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>
                </v-card-text>

                <v-card-actions class="justify-end" style="padding-bottom: 20px;">
                    <v-btn color="secondary" class="mx-3 white--text" @click="forceAssignOrder()">
                        Force Assign
                    </v-btn>

                    <v-btn color="secondary" class="mx-3 white--text"
                        @click="showModal = false; orderAssignmentReason = null">
                        Close
                        <v-icon right dark>mdi-close</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <confirm-dialogue ref="confirmRplcShift"></confirm-dialogue>
        <OrderAssignmentDetailMenu :is-context-menu-open="isContextMenuOpen" :comparisonInfoV2="comparisonInfoV2"
            :comparisonInfoV3="comparisonInfoV3" :orderInfo="comparisionOrderInfo" :isShowReasons="isShowReasons" />
    </v-dialog>
</template>
<script>
import axios from 'axios';
import VueContext from 'vue-context';
import { dateUtils } from '../../../../components/mixins/dateUtils';
import { dataUtils } from '../../../../components/mixins/dataUtils.js';
import draggable from 'vuedraggable';
import whynt from './WhyNot.vue';
import ordView from './Order/OrderView.vue';
import ConfirmDialogue from './../../ConfirmDialogue.vue';

import SplitModal from './Order/SplitModal.vue';

import ShortLoads from '../../Dispatch/Dispatch/Order/ShowLoads.vue';
import showmiddle from '../../Dispatch/Dispatch/Order/ShowLoadsMiddle.vue';
import ShortShift from '../../Dispatch/Dispatch/Order/ShowShifts.vue';
import OrderAssignmentDetailMenu from "../../../Dispatch/OrderAssignmentDetailMenu.vue";
import DispatchService from '../../../../services/DispatchService.js';
import CommonService from '../../../../services/CommonService.js';

export default {
    components: {
        VueContext,
        whynt,
        draggable,
        ordView,
        ShortLoads,
        showmiddle,
        ShortShift,
        SplitModal,
        ConfirmDialogue,
        OrderAssignmentDetailMenu,
    },
    props: ['data_b', 'openViewB', 'header', "shiftHeader"],
    data: function () {
        return {
            showModal: false,
            orderAssignmentReason: null,
            whyNotAssignedParams: {
                OrderID: '', ShiftDetail: '', ForceAssign: false
            },
            dialogSplit: false,
            loadsSplits: null,
            ShiftDetailSplit: null,
            vDialogShifts: false,
            ShiftsInfo: null,
            vDialogLoadMiddle: false,
            LoadsInfo: null,
            vDialogLoads: false,
            LoadsInfoMiddle: null,
            orderGroup: {
                name: 'orders_3',
                pull: true,
                put: true
            },
            dialogOrder: false,
            dataWhy: null,
            viewWhy: false,
            on: false,
            close: false,
            openViewC: false,
            headerProducts: [
                { text: 'Product', value: 'Product', width: '2' },
                { text: 'Ord QTY', value: 'Quantity', width: '2' },
                { text: 'Disp QTY.', value: 'DispatchedQuantity', width: '2' },
                { text: 'OrderID', value: 'OrderID', width: '2' }
            ],
            orderHeaders: [
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    width: '1%',
                    align: 'center',
                },
                {
                    text: 'Seq.',
                    value: 'LoadNum',
                    sortable: false,
                    width: '1%',
                    align: 'center',
                },
                {
                    text: 'Split',
                    value: 'LoadNumOrd',
                    sortable: false,
                    width: '1%',
                    align: 'center',
                },
                {
                    text: 'Order ID',
                    value: 'OrderID',
                    sortable: false,
                    width: '1%',
                    align: 'center',
                },
                {
                    text: 'Terminal',
                    value: 'terminal',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Station',
                    value: 'station',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'City',
                    value: 'city',
                    sortable: false,
                    width: '5%',
                    align: 'center',
                },
                {
                    text: 'Quantity',
                    value: 'Qty',
                    sortable: false,
                    width: '5%',
                    align: 'center',
                },
                {
                    text: 'RT', value: 'RT', sortable: false, width: '5%',
                    align: 'center',
                },
                {
                    text: 'RO', value: 'RO', sortable: false, width: '5%',
                    align: 'center',
                },
                {
                    text: 'ETA', value: 'ETA', sortable: false, width: '5%',
                    align: 'center',
                },
                {
                    text: 'EH',
                    value: 'EstimateTime',
                    sortable: false,
                    width: '5%',
                    align: 'center',
                }
            ],

            headers: [
                {
                    text: 'RT',
                    value: 'RTTime',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'RO',
                    value: 'ROTime',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'ID',
                    value: 'OrderID',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'Terminal',
                    value: 'TerminalName',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'Station',
                    value: 'StationName',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'EH',
                    value: 'EH',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'Dtl',
                    value: 'details',
                    sortable: false,
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },

                {
                    text: '★',
                    value: '★',
                    sortable: false,
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                }
            ],
            orderGroup: {
                name: 'orders',
                pull: true,
                put: true
            },
            ltrs: [],
            orders: {},
            regions: [],
            cbx: null,
            panel: [],
            order: {},
            lineUp: [],
            originalLineUp: [],
            terminals: [],
            search: null,
            filters: ['Terminal', 'Station', 'OrderID', 'StationCity'],
            filterOrd: 'OrderID',

            orderDetailHeaders: [
                [
                    { text: 'Product', value: 'ProductType' },
                    { text: 'Product Code', value: 'ProductCode' },
                    { text: 'Quantity', value: 'DispatchedQuantity' },
                    { text: 'Normalized Quantity', value: 'NormalizedQuantity' }
                ]
            ],
            trailerLimits: {
                6: 60000,
                5: 58000,
                4: 55000,
                3: 30000,
                1: 20000
            },
            isContextMenuOpen: false,
            comparisonInfoV2: [],
            comparisonInfoV3: [],
            comparisionOrderInfo: {},
            isShowReasons: true,
            filteredPlanBData: [],
            pendingRequests: 0,  // Track ongoing API requests
        };
    },
    mixins: [dateUtils],
    mixins: [dataUtils, dateUtils],
    computed: {
        filteredActual() {
            return this.data_b['Actual'].filter(i => {
                return (
                    !this.cbx || i.PrincipalRegion == this.cbx.PrincipalRegionID
                );
            });
        },
        filteredPlanB() {
            return this.data_b['PlanB'].filter(i => {
                return (
                    !this.cbx || i.PrincipalRegion == this.cbx.PrincipalRegionID
                );
            });
        },
        filteredLineUp() {
            return this.lineUp.filter(i => {
                return !this.cbx || i.PrincipalRegionID == this.cbx.PrincipalRegionID;
            });
        },
        filteredOrders() {
            let value;
            return this.filteredLineUp.filter(i => {
                if (this.filterOrd == 'Terminal') {
                    value = i.TerminalName;
                }

                if (this.filterOrd == 'Station') {
                    value = i.StationName;
                }

                if (this.filterOrd == 'StationCity') {
                    value = i.StationCity;
                }

                if (this.filterOrd == 'OrderID') {
                    value = i.OrderID;
                }
                return (
                    !this.search ||
                    (value &&
                        value
                            .toString()
                            .toLowerCase()
                            .includes(this.search.toLowerCase()))
                );
            });
        },
        menuItems(shift) {
            return shift => {
                let items = [];
                items.push({
                    title: 'Replace in Plan A',
                    icon: 'mdi-file-replace',
                    click: () => this.confirmRemplaceShift(shift),
                    condition: true,
                    view: 0
                    // view: this.$store.state.currentUser.id == 106 || this.$store.state.currentUser.id == 39 || this.$store.state.currentUser.id > 197 ? 0 : 1
                });
                return items;
            };
        },
        statusColor(shift) {
            return shift.Finalize || shift.DispatchFinalize
                ? 'green darken-2'
                : 'blue-grey darken-2';
        },
        statusIcon(shift, orders) {
            if (orders != null) {
                // Check if all orders are finalized but the shift is not
                const allOrdersFinalized = orders.every(
                    order => order.Finalize === 1
                );
                if (
                    allOrdersFinalized &&
                    !shift.Finalize &&
                    !shift.DispatchFinalize
                ) {
                    return 'mdi-truck-alert';
                }

                // Check if any order has status INPROGRESS
                if (
                    (orders.some(
                        order => order.OrdLoadStatus === 'INPROGRESS'
                    ) ||
                        orders.some(order => order.OrdLoadStatus === 'DONE')) &&
                    !shift.Finalize &&
                    !shift.DispatchFinalize
                ) {
                    return 'mdi-truck-fast';
                }

                // Check if any order has status READYTOSEND
                if (
                    orders.some(order => order.OrdLoadStatus === 'READYTOSEND')
                ) {
                    return 'mdi-email-alert';
                }

                // Check if shift is finalized
                if (shift.Finalize || shift.DispatchFinalize) {
                    return 'mdi-truck-check';
                }
            } else {
                // Default to not started
                return 'mdi-timer-sand';
            }
        },
        statusIconClass(shift, orders) {
            if (orders != null) {
                // Bouncing icon for shifts in progress
                if (
                    orders.some(order => order.OrdLoadStatus === 'INPROGRESS')
                ) {
                    return 'bouncing';
                }

                // Pulsing icon for READYTOSEND or shift not finalized but orders are finalized
                if (
                    orders.some(
                        order => order.OrdLoadStatus === 'READYTOSEND'
                    ) ||
                    (orders.every(order => order.Finalize === 1) &&
                        !shift.Finalize &&
                        !shift.DispatchFinalize)
                ) {
                    return 'pulsing';
                }
            } else {
                // No class for finalized shifts
                return '';
            }
        },
    },
    mounted() {
        this.fetchRegionAndOrderLineUp()
    },

    methods: {
        shouldHighlightRow(key, value) {
            return !(typeof value === 'boolean' && value);
        },
        isShowLoader(type) {
            this.$store.state.isLoading = type;
        },
        async fetchRegionAndOrderLineUp() {
            this.isShowLoader(true);
            try {
                const [regionResponse, lineUpResponse] = await Promise.all([
                    CommonService.getRegion(),
                    DispatchService.getActiveLineUp()
                ]);

                this.regions = regionResponse.data.filter(x => x.PrincipalRegionID != 4);
                this.lineUp = lineUpResponse.data;
                this.originalLineUp = lineUpResponse.data;

                console.log('Regions:', this.regions);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.isShowLoader(false);
            }
        },
        getGoalPostClass(goalPost) {
            if (goalPost) {
                if (goalPost === "red") return 'goal-post-red';
                if (goalPost === "green") return 'goal-post-green';
                if (goalPost === "yellow") return 'goal-post-yellow';
            } else return 'goal-post-na'
        },

        viewOrder: function (order) {
            this.$store.state.editedOrder.id = order.OrderID;
            this.$store.state.editedOrder.StationID = order.StationID;
            this.$store.state.editedOrder.destiny = 0;
            this.$store.state.order.edt = true;
            this.$store.state.order.type = 'view';
        },

        // viewOrder: function (ord) {
        //     this.$store.state.isLoading = true;
        //     axios
        //         .get('ordersb/show/' + ord.OrderID)
        //         .then(response => {
        //             this.dialogOrder = true;
        //             this.OrderInfo = response.data;
        //         })
        //         .catch(error => {
        //             console.log(error);
        //         })
        //         .finally(() => {
        //             this.$store.state.isLoading = false;
        //         });
        // },
        whyNotHomeLoad: function (ord, search) {
            var parms = {
                OrderID: ord.OrderID,
                TypeSearch: search,
                Shifts: this.filteredPlanB
                    .filter(x => {
                        return x.whyNotCheck == 1;
                    })
                    .map(x => {
                        return x.ShiftDetail;
                    })
            };
            axios
                .post('dispatch-plan-b-v3/why-not', parms)
                .then(response => {
                    this.viewQlf = true;
                    this.dataWhy = response.data;
                    this.viewWhy = true;
                    console.log(response.data);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });
        },
        formatValue(value) {
            if (typeof value === "object") {
                return JSON.stringify(value, null, 2);
            }
            return value;
        },
        splitLoads() {
            this.$store.state.isLoading = true;
            axios
                .get('dispatch-plan-b-v3/shift/split-loads/' + this.shiftHeader.ShiftId)
                .then(response => {
                    console.log(response.data);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });
        },

        printLog: function () {
            console.log(this.filterOrd);
        },
        getBadgeColor(TerminalID) {
            if (!this.terminals) {
                return '';
            } else {
                const terminal = this.terminals.find(
                    t => t.TerminalID == TerminalID
                );
                if (terminal && terminal.Color) {
                    return terminal.Color;
                } else {
                    return '';
                }
            }
        },
        getBadgesByType(driverBadges, type) {
            if (!driverBadges) {
                return [];
            } else {
                return driverBadges.filter(badge => badge.BadgeType == type);
            }
        },
        getOrderLoadStatus(order, type) {
            if (type === 'color') {
                switch (order.OrdLoadStatus) {
                    case 'READYTOSEND': {
                        return 'yellow darken-2';
                    }
                    case 'NOTSTARTED': {
                        return 'blue-grey lighten-2';
                    }
                    case 'INPROGRESS': {
                        return 'blue darken-2';
                    }
                    case 'FORCEDCOMPLETION': {
                        return 'green darken-1';
                    }
                    case 'DONE': {
                        return 'green darken-2';
                    }
                    case 'CANCELLED': {
                        return 'red darken-2';
                    }
                    default: {
                        return 'blue-grey lighten-2';
                    }
                }
            } else if (type === 'icon') {
                switch (order.OrdLoadStatus) {
                    case 'READYTOSEND': {
                        return 'mdi-email';
                    }
                    case 'NOTSTARTED': {
                        return 'mdi-circle-outline';
                    }
                    case 'INPROGRESS': {
                        return 'mdi-truck-fast';
                    }
                    case 'FORCEDCOMPLETION': {
                        return 'mdi-marker-check';
                    }
                    case 'DONE': {
                        return 'mdi-check-circle';
                    }
                    case 'CANCELLED': {
                        return 'mdi-cancel';
                    }
                    default: {
                        return 'mdi-help';
                    }
                }
            } else if (type === 'text') {
                switch (order.OrdLoadStatus) {
                    case 'READYTOSEND': {
                        return 'Ready to Send';
                    }
                    case 'INPROGRESS': {
                        return 'In Progress';
                    }
                    case 'FORCEDCOMPLETION': {
                        return 'Forced Completion';
                    }
                    case 'DONE': {
                        return 'Completed';
                    }
                    case 'CANCELLED': {
                        return 'Cancelled';
                    }
                    default: {
                        return 'Pending';
                    }
                }
            }
        },
        onDragEnd(event) {
            if (event.from !== event.to) {
                const order = event.item;
            }
        },
        getOrderQuantities(order) {
            if (!order.order_details || !Array.isArray(order.order_details)) {
                return 0; // Return 0 if order_details is not present or is not an array
            }

            // Use reduce to sum up DispatchedQuantity from each order detail
            return order.order_details.reduce((total, detail) => {
                // Check if product exists and if MaxCap == 1
                const dispatchedQuantity = detail.DispatchedQuantity || 0;
                const isLSD = detail.product && detail.product.MaxCap == 1;

                // Multiply by 1.14 if the product has MaxCap == 1 (LSD adjustment)
                const adjustedQuantity = isLSD
                    ? dispatchedQuantity * 1.14
                    : dispatchedQuantity;

                // Add the adjusted or non-adjusted dispatched quantity to the total
                return total + adjustedQuantity;
            }, 0);
        },
        closestRunout(order) {
            const orderDetails = order.order_details; // Properties: ProductType (product_id)
            if (order.station == null) {
                const products = order.station.products; // Properties: product_id, safe_runout_at
                //Get the station product that is closest to runout and is present in the order details
                const closestProduct = products
                    .filter(product =>
                        orderDetails.some(
                            detail => detail.ProductType == product.product_id
                        )
                    )
                    .sort((a, b) => {
                        const aRunout = a.safe_runout_at || Infinity;
                        const bRunout = b.safe_runout_at || Infinity;
                        return aRunout - bRunout;
                    })[0];

                if (!closestProduct) {
                    return null;
                }

                return closestProduct.safe_runout_at;
            }
        },
        checkTrailerCapacity(loadedQuantity, type) {
            const capacity = this.trailerLimits[this.trailerAxles];
            if (!capacity) {
                console.error(
                    // `Trailer capacity not found. Axles: ${this.trailerAxles} Quantity: ${loadedQuantity}`
                );
                return;
            }
            switch (type) {
                case 'color':
                    if (loadedQuantity > capacity) {
                        //Red pastel hex color code if the quantity is greater than the capacity
                        return '#000';
                    } else if (loadedQuantity == capacity) {
                        //Green pastel hex color code if the quantity is equal to the capacity
                        return '#000';
                    } else {
                        //Yellow pastel hex color code if the quantity is less than the capacity
                        return '#dda90d';
                    }
                case 'icon':
                    if (loadedQuantity > capacity) {
                        return 'mdi-truck-alert';
                    } else if (loadedQuantity == capacity) {
                        return 'mdi-truck-check';
                    } else {
                        return 'mdi-truck-fast';
                    }
                case 'text':
                    if (loadedQuantity > capacity) {
                        return 'Overloaded';
                    } else if (loadedQuantity == capacity) {
                        return 'Full';
                    } else {
                        return 'OK';
                    }
                case 'boolean':
                    return loadedQuantity >= capacity ? true : false;
                default:
                    console.error(`Invalid type: ${type}`);
                    return;
            }
        },
        openAutoAssignQuantities(order) {
            this.selectedOrder = order;
            this.dialogs.autoAssignQuantities = true;
        },
        draggingOrder(event) {
            console.log(event);
        },
        possibleHml: async function () {
            const shiftDetail = await prompt("Enter an ShiftDetail Number");
            if (shiftDetail) {
                this.$store.state.isLoading = true;
                axios
                    .get('dispatch-plan-b-v3/short/loads/' + shiftDetail)
                    .then(response => {
                        console.log(response.data);
                        this.LoadsInfo = response.data;
                        this.vDialogLoads = true;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$store.state.isLoading = false;
                    });
            }
        },
        possibleMiddle: async function () {
            const shiftDetail = await prompt("Enter an ShiftDetail Number");
            if (shiftDetail) {
                this.$store.state.isLoading = true;
                axios
                    .get('dispatch-plan-b-v3/short/loads/middle/' + shiftDetail)
                    .then(response => {
                        console.log(response.data);
                        this.LoadsInfoMiddle = response.data;
                        this.vDialogLoadMiddle = true;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$store.state.isLoading = false;
                    });
            }
        },
        possibleShifts: async function (ord) {
            const orderNum = await prompt("Enter an Order Number");
            if (orderNum) {
                this.$store.state.isLoading = true;
                axios
                    .get('dispatch-plan-b-v3/short/shifts/' + orderNum + '/' + this.$store.state.shiftId.ShiftId)
                    .then(response => {
                        console.log(response.data);
                        this.ShiftsInfo = response.data;
                        this.vDialogShifts = true;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$store.state.isLoading = false;
                    });
            }
        },
        remplacePlanA: async function (ord) {
            this.$store.state.isLoading = true;
            axios
                .get('dispatch-plan-b-v3/temporal/update/orders/' + this.$store.state.shiftId.ShiftId)
                .then(response => {
                    console.log(response.data);

                    this.$emit('close');
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });
        },
        remplacePlanAShiftByShift: async function (shift) {
            this.$store.state.isLoading = true;
            axios
                .get('dispatch-plan-b-v3/temporal/update/shift/orders/' + shift.ShiftDetail + '/' + this.$store.state.shiftId.ShiftId)
                .then(response => {
                    console.log(response.data);

                    this.$emit('close');
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });
        },
        async reorderLoads(orders, shift, bl) {
            let LoadNum = 1;
            let loadNumOrd = null;
            for (const index in orders) {
                if (index == 0) {
                    console.log(orders[index], index, 'First')
                    console.log(LoadNum, orders[index].LoadNum)
                    orders[index].LoadNum = LoadNum;
                    if (orders[index].LoadNumOrd != null) {
                        if (orders[index].LoadNumOrd == 1) {
                            loadNumOrd == orders[index].LoadNumOrd;
                        }
                        loadNumOrd++;
                        orders[index].LoadNumOrd = loadNumOrd;
                    } else {
                        loadNumOrd = null;
                        LoadNum++;
                    }
                } else {
                    // 
                    if (orders[index].LoadNumOrd != null) { // El Load Actual es Multiload
                        if (orders[index - 1].LoadNumOrd == null) { // Si el load anterior fue Single
                            // LoadNum++;
                            if (LoadNum == orders[index].LoadNum) { //El LoadNum es == al Actual
                                if (orders[index].loadNumOrd == 1) {
                                    LoadNum++;
                                    orders[index].LoadNum = LoadNum;
                                    loadNumOrd = 1;
                                } else {
                                    orders[index].LoadNum = LoadNum;
                                    loadNumOrd = 1;
                                }
                            } else {
                                if (orders[index].loadNumOrd == 1) {
                                    LoadNum++;
                                    orders[index].LoadNum = LoadNum;
                                    loadNumOrd = 1;
                                } else {
                                    orders[index].LoadNum = LoadNum;
                                    loadNumOrd = 1;
                                }
                            }
                        } else {
                            if (LoadNum == orders[index].LoadNum) {
                                orders[index].LoadNum = LoadNum;
                                loadNumOrd++;
                            } else {
                                if (orders[index].LoadNumOrd == 1) {
                                    LoadNum++;
                                    loadNumOrd = 1;
                                    orders[index].LoadNum = LoadNum;
                                    if (orders[(Number(index) + + 1)].LoadNumOrd != null) {
                                        orders[(Number(index) + + 1)].LoadNum = LoadNum;
                                    }
                                } else {
                                    orders[index].LoadNum = LoadNum;
                                    loadNumOrd++;

                                }
                            }
                        }
                        console.log(orders[index], 'Here')
                        if (typeof orders[(Number(index) + + 1)] !== 'undefined') {
                            if (orders[(Number(index) + + 1)].LoadNumOrd == null) {
                                console.log(orders[(Number(index) + + 1)], 'fined')
                                LoadNum++;
                            }
                        }
                        orders[index].LoadNumOrd = loadNumOrd;
                    } else {
                        orders[index].LoadNum = LoadNum;
                        loadNumOrd = null;
                        LoadNum++;
                    }
                }
            }
            if (bl) {
                const parms = await orders.map(x => {
                    return {
                        OrderID: x.OrderID,
                        LoadNum: x.LoadNum,
                        LoadNumOrd: x.LoadNumOrd
                    }
                })
                this.updateLoadNum(parms, shift.ShiftDetail);
            }
        },
        forceAssignOrder: async function () {
            this.whyNotAssignedParams.ForceAssign = true;
            await this.validateAndOrder()
        },
        validateAndOrder: async function () {
            this.$store.state.isLoading = true;
            axios.post('dispatch-plan-b-v3/why-not-assigned', this.whyNotAssignedParams).then(response => {
                const whyNotAssignedResponse = response.data.data;
                if (!whyNotAssignedResponse.assignment) {
                    this.showModal = true;
                    this.orderAssignmentReason = whyNotAssignedResponse.reasons;
                    this.lineUp = JSON.parse(JSON.stringify(this.originalLineUp));
                    axios
                        .get('dispatch-plan-b-v3/show/' + this.shiftHeader.ShiftId)
                        .then(response => {
                            this.data_b = JSON.parse(JSON.stringify(response.data));
                        })
                        .catch(function (error) {
                            console.log(error);
                            this.$store.state.isLoading = false;
                        }).finally(() => {
                            this.$store.state.isLoading = false;
                        });
                } else {
                    axios
                        .get('dispatch-plan-b-v3/show/' + this.shiftHeader.ShiftId)
                        .then(response => {
                            this.data_b = JSON.parse(JSON.stringify(response.data));
                            const filteredLineUp = this.lineUp.filter(lineUp => lineUp.OrderID !== this.whyNotAssignedParams.OrderID);
                            this.lineUp = JSON.parse(JSON.stringify(filteredLineUp));
                            this.originalLineUp = JSON.parse(JSON.stringify(filteredLineUp));
                        })
                        .catch(function (error) {
                            console.log(error);
                            this.$store.state.isLoading = false;
                        }).finally(() => {
                            this.$store.state.isLoading = false;
                            this.showModal = false;
                            this.orderAssignmentReason = null;
                        });
                }
            })
        },
        addOrder: async function (orders, shift) {
            this.$store.state.OnFrom = 'Shift';
            this.$store.state.isLoading = true;
            let str = this.$store;
            let shiftPrev = 0;
            await this.reorderLoads(orders, shift, 0);
            console.log(shift)
            console.log(orders)
            const idx = await orders.findIndex(x => {
                return x.OrderStatus == "ACTIVE" && x.ShiftDetail == 0 || x.OrderStatus == "PRLDHELD" && x.ShiftDetail == 0
                    || x.OrderStatus == "DISPATCHED" && x.ShiftDetail != shift.ShiftDetail;
            });

            if (idx === -1) {
                this.$store.state.isLoading = false;
                return;
            }

            if (orders[idx].ShiftDetail > 0) {
                shiftPrev = orders[idx].ShiftDetail;
            }

            let match = 1;
            if (orders[idx].isSpecific != shift.isSpecific) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'The specific product does not match'
                });
                match = 0;
                this.$store.state.isLoading = false;
            }

            if (match) {
                if (orders[idx].OrderStatus == "ACTIVE") {
                    orders[idx].OrderStatus = "DISPATCHED";
                }
                else if (orders[idx].OrderStatus == "PRLDHELD" || orders[idx].OrderStatus == "PRLDISPAT")
                    orders[idx].OrderStatus = "PRLDISPAT";
                else {
                    orders[idx].OrderStatus = "DISPATCHED";
                    await this.reorderLoads(orders, shift, 0);
                }
                const orderId = orders[idx].OrderID;
                const shiftDetail = shift.ShiftDetail;

                this.whyNotAssignedParams = {
                    OrderID: orderId, ShiftDetail: shiftDetail, ForceAssign: false
                }

                await this.validateAndOrder();
            }
        },

        removeOrder: async function (orders, shift, event) {
            this.$store.state.isLoading = true;
            const params = {
                ShiftDetail: shift.ShiftDetail,
                OrderID: this.OrderSelect.OrderID
            };

            const toAttachElement = Number(event.to.id);
            const toBeAttachedShift = this.filteredPlanB.find(data => data.ShiftDetail === toAttachElement);

            if (toBeAttachedShift) {
                this.$store.state.isLoading = false;
                return;
            }

            await axios
                .post('dispatch-plan-b-v3/order/unassign-order/', params)
                .then(response => {
                    axios
                        .get('dispatch-plan-b-v3/show/' + this.shiftHeader.ShiftId)
                        .then(response => {
                            this.data_b = response.data;
                            axios
                                .get('dispatch-plan-b-v3/lineup/active')
                                .then(response => {
                                    this.lineUp = response.data;
                                    this.originalLineUp = response.data;
                                    this.$store.state.isLoading = false;
                                })
                                .catch(error => {
                                    console.log(error);
                                })
                                .finally(() => {
                                    this.$store.state.isLoading = false;
                                });
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                })
                .catch(error => {
                    console.log(error);
                })
        },
        onDragStart(orders, event) {
            this.$store.state.OnOrigin = "Shift";
            this.OrderSelect = orders[event.oldDraggableIndex];
            console.log(this.OrderSelect)
        },

        onDragListener: function (evt) {
            console.log('hola', evt);
        },
        onDragEndListener: function (evt) {
            console.log('hola end', evt);
        },
        updateLoadNum: function (parms, shiftDetail) {
            this.$store.state.isLoading = true;
            const orderIds = parms.map(data => data.OrderID);
            const payload = {
                ShiftDetail: shiftDetail, Orders: orderIds
            }
            axios
                .post('dispatch-plan-b-v3/order/rearrange-order', payload)
                .then(response => {
                    axios
                        .get('dispatch-plan-b-v3/show/' + this.shiftHeader.ShiftId)
                        .then(response => {
                            this.data_b = JSON.parse(JSON.stringify(response.data));
                        })
                        .catch(function (error) {
                            console.log(error);
                            this.$store.state.isLoading = false;
                        }).finally(() => {
                            this.$store.state.isLoading = false;
                        });
                })
                .catch(error => {
                    console.log(error);
                })
        },

        getOrdersByShiftDetail: async function (shiftDetail) {
            var str = this.$store;
            console.log(shiftDetail)
            await axios
                .post('dispatch-plan-b-v3/order/shift/new/' + shiftDetail.ShiftDetail, {})
                .then(response => {
                    shiftDetail.orders_3 = JSON.parse(JSON.stringify(response.data));
                })
                .catch(function (error) {
                    console.log(error);
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        splitOrder: async function (x) {
            var str = this.$store;
            this.ShiftDetailSplit = x.ShiftDetail;
            const idxOrd = await this.filteredPlanB.findIndex(elm => {
                return elm.ShiftDetail == x.ShiftDetail;
            })
            const origin = await this.filteredPlanB[idxOrd].orders_3.findIndex(elm => {
                return elm.OrderID == x.OrderID;
            });
            if (origin == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'A loadnum greater than 1 is required.'
                });
            } else {
                //    Find loads when LoadNum is the same 
                const loads = this.filteredPlanB[idxOrd].orders_3.filter(x => {
                    return x.LoadNum == this.filteredPlanB[idxOrd].orders_3[origin - 1].LoadNum;
                })
                if (this.filteredPlanB[idxOrd].orders_3[origin].LoadNumOrd == null) {
                    loads.push(x);
                }
                this.loadsSplits = loads;
                this.dialogSplit = true;
            }
        },

        splitsSave: async function () {
            this.$store.state.isLoading = true;
            axios
                .get('dispatch-plan-b-v3/show/' + this.shiftHeader.ShiftId)
                .then(response => {
                    this.data_b = JSON.parse(JSON.stringify(response.data));
                })
                .catch(function (error) {
                    console.log(error);
                }).finally(() => {
                    this.dialogSplit = false;
                    this.$store.state.isLoading = false;
                });
        },
        async confirmRemplace() {
            const ok = await this.$refs.confirmRplc.show({
                title: 'Are you sure to run remplace Plan A',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.remplacePlanA();
            }
        },
        async confirmRemplaceShift(shift) {
            const ok = await this.$refs.confirmRplcShift.show({
                title: 'are you sure to replace this shift in Plan A',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.remplacePlanAShiftByShift(shift);
            }
        },

        unSplitOrder: function (order) {
            var str = this.$store;

            const idxOrd = this.filteredPlanB.find(elm => {
                return elm.ShiftDetail == order.ShiftDetail;
            })

            const payload = idxOrd.orders_3.map((order, index) => {
                return {
                    OrderID: order.OrderID,
                    SplitTypeID: null,
                    LoadNum: index + 1,
                    LoadNumOrd: null
                }
            })

            str.state.isLoading = true;
            axios.post('dispatch-plan-b-v3/order/update/split/' + order.ShiftDetail, payload)
                .then(async response => {
                    console.log(response.data);

                    const idxOrd = await this.filteredPlanB.findIndex(elm => {
                        return elm.ShiftDetail == order.ShiftDetail;
                    })
                    this.reorderLoads(this.filteredPlanB[idxOrd].orders_3, this.filteredPlanB[idxOrd], 1);
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },

        getOrderDetails: async function (orderID, isShowReasons = true) {
            try {
                const url = `dispatch-plan-b-v3/shift/ranking/${orderID}`;
                this.isContextMenuOpen = true;
                this.isShowReasons = isShowReasons;

                const response = await axios.get(url);
                this.comparisonInfoV2 = response.data.data.comparison_info_v2;
                this.comparisonInfoV3 = response.data.data.comparison_info;
                this.comparisionOrderInfo = response.data.data.order_info
            } catch (error) {
                console.error("Error fetching order details:", error);
            }
        },

        parsedDurationBreakup(duration_breakup) {
            try {
                return duration_breakup ? JSON.parse(duration_breakup) : null;
            } catch (e) {
                console.error("Error parsing duration_breakup:", e);
                return null;
            }
        },

        getEHEventKeyNameForDurationBreakUp(keyName, orders, shift, index) {
            const order = orders[index];
            const previousOrder = orders[index - 1];

            const yardName = shift?.Yard || "Yard";
            const stationName = order?.StationName || "Station";
            const terminalName = order?.TerminalName || "Terminal";
            const previousStationName = previousOrder?.StationName || "Previous Station";

            switch (keyName) {
                case "Time at Yard":
                case "Time At Yard":
                    return `<span class="purple-icon">Y</span> Time at ${yardName}`;

                case "Yard to Station":
                    return `<span class="purple-icon">YS</span> ${yardName} to ${stationName}`;

                case "Time at Station":
                case "Time At Station":
                    return `<span class="purple-icon">S</span> Time at ${stationName}`;

                case "Station to Yard":
                    return `<span class="purple-icon">SY</span> ${stationName} to ${yardName}`;

                case "Time at Exit Yard":
                    return `<span class="purple-icon">Y</span> Time at Exit ${yardName}`;

                case "Time to arrive Terminal":
                case "Time to Arrive Terminal":
                    return `<span class="purple-icon">YT</span> ${yardName} to ${terminalName}`;

                case "Time at Terminal":
                    return `<span class="purple-icon">T</span> Time at ${terminalName}`;

                case "Terminal to Yard":
                    return `<span class="purple-icon">TY</span> ${terminalName} to ${yardName}`;

                case "From Terminal to Station":
                    return `<span class="purple-icon">TS</span> ${terminalName} to ${stationName}`;

                case "From Previous station to station":
                    return `<span class="purple-icon">PS→S</span> ${previousStationName} to ${stationName}`;

                case "Terminal to Station":
                    return `<span class="purple-icon">TS</span> ${terminalName} to ${stationName}`;

                default:
                    return `<span class="gray-icon">??</span> ${keyName}`;
            }
        },
        an_getEHEventKeyNameForDurationBreakUp(keyName, value, orders, shift, index) {
            const order = orders[index];
            const previousOrder = orders[index - 1];
            const yardName = shift?.Yard || "Yard";
            const stationName = order?.StationName || "Station";
            const terminalName = order?.TerminalName || "Terminal";
            const previousStationName = previousOrder?.StationName || "Previous Station";
            //dp_code
            let uid_key = [];
            if (value && value.dp_code) {
                uid_key = value.dp_code.split('2');
            }
            else {
                return '---';
            }
            const mapping = {
                s: { "type": "Station", "name": stationName },
                t: { "type": "Terminal", "name": terminalName },
                y: { "type": "Yard", "name": yardName },
                ps: { "type": "Previous Station", "name": previousStationName },
                // "pt":{"type":"Previous Terminal","name":}
            }
            const uid_key_1 = uid_key[0];
            const uid_key_2 = uid_key[1];
            if (uid_key_1 == uid_key_2) {
                let name = mapping[uid_key_1].name;
                return `<span class="purple-icon">${uid_key_1.toUpperCase()}</span> Time at ${name}`;
            }
            else {
                let from_name = mapping[uid_key_1].name;
                let to_name = mapping[uid_key_2].name;
                return `<span class="purple-icon">${uid_key_1.toUpperCase()}${uid_key_2.toUpperCase()}</span>From ${from_name} to ${to_name}`;
            }

        },
        getCalculationMethod(source) {
            if (!source) return "";

            if (source.includes("Geotab")) {
                return `Geotab`;
            }

            if (source.includes("Google")) {
                return `Google`;
            }

            return source;
        },


        totalDuration(duration_breakup) {
            if (!this.parsedDurationBreakup(duration_breakup)) return "0.00";
            const total = Object.values(this.parsedDurationBreakup(duration_breakup)).reduce((sum, item) => sum + (item.time || 0), 0);
            return total.toFixed(2); // Rounds to 2 decimal places
        }
    }
};
</script>
<style>
#canvas {
    background-image: url('../../../../assets/trailer.png');
}

.ghost {
    opacity: 0.5;
}

.highlight-rows {
    font-weight: 600;
    background-color: #c50707;
    color: white;
    pointer-events: none
}

.purple-icon {
    display: inline-block;
    width: 22px;
    height: 22px;
    background-color: rgb(1, 87, 155);
    color: white;
    font-weight: bold;
    border-radius: 5px;
    text-align: center;
    line-height: 20px;
    font-size: 11px;
    margin-right: 5px;
    vertical-align: bottom;
}

.goal-post-circle {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-left: 8px;
}

.goal-post-green {
    background-color: #28a745;
}

.goal-post-yellow {
    background-color: #ffc107;
}

.goal-post-red {
    background-color: #dc3545;
}
</style>
